import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectEmailAccountsQueryItems } from '../../../../../redux/email-accounts/selector';
import { emailAccounts } from '../../../../../redux/email-accounts/action';
import PageLoader from '../../../../../components/PageLoader';
import EmailAccountComponent from '../components/email-account.component';

const ManagementEmailAccount = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const emailAccountsQuery = useSelector(selectEmailAccountsQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)

  const [
    selectEmailAccounts,
    setSelectEmailAccounts
  ] = useState<any>([])

  const fetchEmailAccountsQueryById= ()=>{
    dispatch(emailAccounts.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/email-accounts/query`,entity:'emailAccounts',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectEmailAccounts({ ...selectEmailAccounts, [field]: event })
  }

  useEffect(
    () => {
            if (parmas?.id > 0) {
                fetchEmailAccountsQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
         
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectEmailAccounts(emailAccountsQuery?.result?.items)
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
      if (parmas?.id > 0) {
     dispatch(emailAccounts.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/email-accounts`,entity:'emailAccounts',jsonData:{
          
    Records: [
        selectEmailAccounts
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(emailAccounts.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/email-accounts`,entity:'emailAccounts',jsonData:{
            
        Records: [
            selectEmailAccounts
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
 
const back=()=>{
  navigate('/management/configuration/email-accounts')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <EmailAccountComponent 
          handleInnerFormChange={handleInnerbasicFormChange}
          selectEmailAccounts={selectEmailAccounts}
          back={back}
          handleFormSubmit={handleFormSubmit}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementEmailAccount;